import JobHardwareCapabilityForm from './JobHardwareCapabilityForm';

export default JobHardwareCapabilityForm;
